module.exports = __webpack_public_path__ + "static/media/expertentelefon-white.4862c8ae.svg";